import api from "./API";
import axios from "axios";
const packageJson = require("../../package.json");
const createSignature = () => {
  const secretKey = "5d928cd2-77d1-4415-abbb-4f225f40ee65";
  return secretKey;
};
// Auth
export const getUserNameByGId = async (GrowniverseId: string, IsSingup = false) =>
  (await api.get(`Auth?GrowniverseId=${GrowniverseId}&IsSingup=${IsSingup}`)).data;

export const putUserSignOpt = async (userData: any) =>
  (await api.put("Auth", userData)).data;

export const putUserLogin = async (userData: any) => {
    const signature = createSignature();
    const appKey = localStorage.getItem("appkey");
    const responseApi = await axios.post(packageJson.apiUrl + "Auth", userData, {
        headers: {
            "Content-Type": "application/json",
            'X-Growniverse-Signature': signature,
            "X-Growniverse-Appkey": appKey
        },
    });
    return responseApi.data;
}

export const activateEmailAsync = async (userData: any) =>
  (await api.post("Auth/EmailConfirmation", userData)).data;

export const userUpdate = async (userData: any) =>
  (await api.post("Auth/UpdateProfile", userData, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;

export const GetUserReferral = async (GrowniverseId: string) =>
  (await api.get(`Auth/UserReferral?GrowniverseId=${GrowniverseId}`)).data;

export const getAdminPannel = async (AdminDetail = 1) =>
  (await api.get(`Auth/AdminPannel?AdminDetail=${AdminDetail}`)).data;

export const passwordChange = async (userData: any) =>
  (await api.post("Auth/PasswordChange", userData)).data;

export const sendKycForApproval = async (userData: any) =>
  (await api.post("Auth/KycRequest", userData, {
    headers: { "Content-Type": "multipart/form-data" },
  })).data;

export const kycRequestAction = async (userData: any) =>
  (await api.patch("Auth/KycAction", userData)).data;

export const updateUser = async (userData: any) =>
  (await api.patch("Auth/UpdateUser", userData)).data;

export const resetPassword = async (userData: any) =>
  (await api.post("Auth/ResetPassword", userData)).data;

export const dashboard = async (request = 1) =>
  (await api.get(`Auth/Dashboard?DashboardRequest=${request}`)).data;
